if (!customElements.get('product-card-atc-js')) {
  window.$s = window.$s || new function (){
    this.formatMoney = function(cents, format) {
      if(typeof cents == 'string') { cents = cents.replace('.',''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || window.money_format);

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if(isNaN(number) || number == null) {return 0;}

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }
      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
    this.imgUrlFilter = function(url, filter) {
      var position = url.split('?')[0].lastIndexOf('.');
      url = url.substring(0, position) + '_' + filter + url.substring(position);
      return url;
    }
    this.handleize = function(str) {
        if(typeof str === 'string') return str.toLowerCase().replace(/\'|\"/g, "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, ""); 
    }
  }

  class ComponentProductCardAtcJs extends HTMLElement {
    constructor() {
      super();  
      
      //this objerver is set so the cards rebuilds when the json attribute is changed. This was a request from SS as they changed the variant colors after initialization
      var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && this.initialized) {
            var newJson = JSON.parse(this.dataset.json);
            if(JSON.stringify(this.json) != JSON.stringify(newJson))
            { 
              this.json = newJson;
              this.innerHTML = this.buildHtml();
            }
          }
          
        });
      });

      observer.observe(this, {
        attributes: true //configure it to listen to attribute changes
      });
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      this.dataset.imgMode = "hover";
      this.dataset.quickview = true;
      this.dataset.textAlign = "left";
      this.dataset.cssClass = 'normal'; //normal, hover-expand, hover-expand colors-out
      this.dataset.showQuantity = true;

      this.json = JSON.parse(this.dataset.json);
      this.eyebrowConfig = JSON.parse(document.querySelector('#eyebrow-config-script').textContent);

      if (this.json.images.length==0) {
        this.json.images.push({
        "alt": "",
        "src": "\/\/spartina449.com\/cdn\/shop\/t\/539\/assets\/placeholder.png?v=1593909494867914621762292421",
        "width": 100,
        "height": 125
        });
      }
      this.defaultVariant = this.json.variants.find(x=>x.id==this.json.default_variant || !this.json.default_variant);

      //render all html
      this.innerHTML = this.buildHtml();

      this.quickViewBtn = this.querySelector('.quick-view-trigger');
      //if(this.quickViewBtn)
        //this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
    }

    getImgSrcSet(imgData) {
      const sizes = [180,360,540,720,900,1080];
      var ret = [];
      var item;
      for (var i=0; i<sizes.length; i++) {
        if (imgData.width > sizes[i]) {
          item = $s.imgUrlFilter(imgData.src, sizes[i]+'x') + ' ' + sizes[i] + 'w';
          ret.push(item);
        } else {
          item = imgData.src + ' ' + imgData.width + 'w';
          ret.push(item);
          break;
        }
      }

      return ret.join(', ');

    }

    checkTags() {
      let elements = '';
      if (this.json.tags) {
        this.json.tags.forEach(productTag => {
          this.eyebrowConfig.eyebrow_blocks.forEach(eyebrowBlock => {
            if (productTag == eyebrowBlock.product_tag_id) {
              elements += `<p style="color: ${this.eyebrowConfig.eyebrows_color}; margin-bottom: 0; margin-top: .3em;">${eyebrowBlock.content}</p>`;
            }
          });
        })
      }
      return elements;
    }

    getVariantByOptionName(optionName) {
      var optionNameSplit = optionName.split(':');
      var optionName = optionNameSplit[0];
      var optionValue = optionNameSplit[1];

      var variant = this.json.variants.find(function(v) {
        return v.title.toLowerCase() == optionValue.toLowerCase();
      });

      return variant;
    }

    buildHtml() {
      if (window.location.pathname.includes('collections')) {
        var collectionHandle = window.location.pathname.split('/').pop();
        var includedTag = '';
        if(this.json.tags){
          var containsOptionValueString = this.json.tags.some(str => {
            var handleizedTag = str.toLowerCase().replace(':', '-').replace(' ', '');
    
            if (collectionHandle.includes(handleizedTag)) {
              includedTag = str;
              return true;
            }
          })
        }
        var defaultVariant = (includedTag != '') ? this.getVariantByOptionName(includedTag.replace(' ', '')) : this.defaultVariant;
        this.defaultVariant = defaultVariant || this.defaultVariant;
      }

      var html = `
<product-card-atc data-section="${this.dataset.sectionId}-${this.json.id}" data-product-id="${this.json.id}" class="product-card product-main-element atc text-${this.dataset.textAlign} ${this.dataset.cssClass} ${(this.defaultVariant.compare_at_price > this.defaultVariant.price) ? 'on-sale':''}" id="main-product-${this.dataset.sectionId}-${this.json.id}">
  <a href="#" data-with-epi="true" class="wishlist-btn swym-add-to-wishlist-view-product product_${this.json.id}" data-swaction="addToWishlist" data-product-id="${this.json.id}" data-variant-id="${this.json.default_variant}" data-product-url="${this.json.shop_url}${this.json.url}" aria-label="Save for later">
    <svg aria-hidden="true" role="presentation" class="icon icon-wishlist" viewbox="0 0 32 32"><path d="M16,30.1c-0.3,0-0.5,0-0.8-0.2c-0.2-0.1-0.5-0.3-0.7-0.5L2.5,16.9c-0.8-0.8-1.5-1.9-1.9-3C0.2,12.8,0,11.6,0,10.4C0,9.2,0.3,8.1,0.8,7c0.5-1.1,1.2-2.1,2-2.9c0.8-0.8,1.8-1.3,2.8-1.7c1-0.4,2.1-0.5,3.2-0.4c2.2,0.2,4.3,1.1,5.9,2.8L16,6.1l1.6-1.7c0.8-0.8,1.8-1.5,2.8-2c1.1-0.4,2.2-0.7,3.4-0.6c1.1,0,2.3,0.3,3.3,0.8c1,0.5,2,1.2,2.7,2.1c0.7,0.9,1.3,1.9,1.6,2.9c0.4,1.1,0.5,2.2,0.4,3.4c-0.1,2.3-1.1,4.5-2.7,6.1L17.5,29.5c-0.2,0.2-0.4,0.4-0.7,0.5C16.6,30.1,16.3,30.1,16,30.1L16,30.1z M8.3,3.8C6.7,3.8,5.2,4.4,4,5.5C3.3,6.1,2.8,6.9,2.4,7.8C2,8.6,1.8,9.5,1.8,10.5c0,0.9,0.1,1.9,0.5,2.8c0.3,0.9,0.8,1.7,1.5,2.3l12.1,12.6c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1l11.8-12.3c2.7-2.8,2.9-7.2,0.6-9.9c-0.6-0.7-1.3-1.3-2.2-1.7c-0.8-0.4-1.7-0.6-2.6-0.6c-0.9,0-1.8,0.1-2.7,0.5c-0.8,0.4-1.6,0.9-2.3,1.6l-2.2,2.3c-0.2,0.2-0.4,0.3-0.6,0.3c-0.2,0-0.5-0.1-0.6-0.3l-1.9-2c-0.7-0.7-1.5-1.3-2.4-1.7C10.2,4,9.3,3.8,8.3,3.8L8.3,3.8z"fill="currentColor"></path></svg>
    <svg aria-hidden="true" role="presentation" class="icon icon-wishlist-added" viewBox="0 0 32 32"><path d="M29.3,17.4l-11.6,12c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.7-0.5L2.5,17.1c-0.8-0.9-1.5-1.9-1.9-3C0.2,13,0,11.8,0,10.6c0-1.2,0.3-2.4,0.8-3.5C1.3,6,2,5,2.9,4.2C6.2,1,11.6,1.3,15,4.8l1.1,1.1l1.4-1.4c0.8-0.9,1.8-1.5,2.9-2c1.1-0.4,2.2-0.7,3.4-0.6c1.2,0,2.3,0.3,3.4,0.8c1.1,0.5,2,1.2,2.8,2.1C32.9,8.3,32.6,13.9,29.3,17.4L29.3,17.4z"/></svg>
  </a>
  <a href="${this.json.url}${(defaultVariant) ? `?variant=${defaultVariant.id}` : ''}" class="product-card-url">
    <div class="image-container">
      ` + (this.dataset.imgMode=='hover' ? `
      <div class="image show-hover-image">
        <img class="img main lazyload" alt="" data-sizes="auto" data-srcset="${this.getImgSrcSet(this.json.images[0])}" width="${this.json.images[0].width}" height="${this.json.images[0].height}" />
        ` + (this.json.images.length > 1 ? `
          <img class="img hover-img animation lazyload" alt="" data-sizes="auto" data-srcset="${this.getImgSrcSet(this.json.images[1])}" width="${this.json.images[1].width}" height="${this.json.images[1].height}" />
        ` : ``) + `
      </div>
      ` : `
    <div class="image">
      <img class="img main lazyload" alt="" data-sizes="auto" data-srcset="${this.getImgSrcSet(this.json.images[0])}" width="${this.json.images[0].width}" height="${this.json.images[0].height}" />
    </div>      
      `) + `

      ` + (this.json.customBadge ? `<div class="badge custom-badge bottom-left">${this.json.customBadge}</div>` : `` ) + `` + (this.dataset.quickview ? `
        <div tabindex="0" role="button" class="quick-view-trigger btn" data-url="${this.json.url + '?variant=' + this.defaultVariant.id}&view=quick-view">
          Quick View
        </div>
      ` : ``) + `
    </div>
    <div class="info cart-hide">
      ` + (this.json.eyebrow ? `<div class="eyebrow">${this.json.eyebrow}</div>` : ``) + `
      <div class="title">${this.json.title}</div>
      
      ${(containsOptionValueString) ? `<div class="custom-tag-subtitle">${includedTag}</div>` : ''}
      <div class="price-swatches-wrapper flex justify-content-between align-items-center small--align-items-start small--direction-column">
        <div class="price flex direction-row justify-content-${this.dataset.textAlign.replace('left','start').replace('right','end')} small--direction-column">
          ` + (this.json.price_min != this.json.price_max ? `<div class="from">From</div>` : ``) + `
          <span class="final ${( this.json.compare_at_price > this.json.price ) ? '' : 'regular-final'}">${$s.formatMoney(this.json.price_min)}</span>
          <span class="compare ` + (!(this.json.compare_at_price_min > this.json.price_min) ? `hide` : ``) + `">${$s.formatMoney(this.json.compare_at_price)}</span>
        </div>

        ` + (this.json.color_variant && this.json.color_variant != '' ? `
        <div class="available-colors">
          <div class="swatch-group inline-swatch-group flex align-items-center">
            <label title="${this.json.current_color}" class="swatch flex color-${$s.handleize(this.json.current_color)} align-items-center justify-content-center selected">
              <span class="visually-hidden">${this.json.current_color}</span>
            </label>
        ` : (this.json.variants.length > 1 ? `
        <div class="available-colors">
          <div class="swatch-group inline-swatch-group flex align-items-center">
        ` : ``))
        var swatchesHtml = '';
        this.json.color_variant && this.json.color_variant.forEach((colorVariant) => {
          const handleizedTitle = $s.handleize(colorVariant.color);
          swatchesHtml += `<label title="${colorVariant.color}" class="swatch color-${handleizedTitle} flex align-items-center justify-content-center">
                            <span class="visually-hidden">${colorVariant.color}</span>
                          </label>`
        })

        this.json.variants.length > 1 && this.json.options.forEach((option,ix)=> {
          if (option=='Color' || option=='Metal') {
            this.json.variants.forEach((v) => {
              const handleizedTitle = $s.handleize(v.title);
              swatchesHtml += `<a href="${this.json.url}?variant=${v.id}"><span title="${v.title}" class="swatch label color-${handleizedTitle} flex align-items-center justify-content-center"><span class="visually-hidden">${v.title}</span></span></a>`
            });
          }
        });

        swatchesHtml += `</div></div>`

        html += swatchesHtml;

        html += `
      </div>
    </div>
    ` + (this.checkTags()) + `
  </a>

  <add-to-cart-form class="flex direction-column">
    <div class="info small--hide cart-show">
      ` + (this.json.eyebrow ? `<div class="eyebrow">${this.json.eyebrow}</div>` : ``) + `
      <div class="title">${this.json.title}</div>
      <div class="price-swatches-wrapper flex justify-content-between align-items-center small--direction-column small--align-items-start">
        <div class="price flex justify-content-${this.dataset.textAlign.replace('left','start').replace('right','end')}">
          ` + (this.json.price_min != this.json.price_max ? `<div class="from">From</div>` : ``) + `
          <span class="final ${( this.json.compare_at_price > this.json.price ) ? '' : 'regular-final'}">${$s.formatMoney(this.json.price_min)}</span>
          <span class="compare ` + (!(this.json.compare_at_price_min > this.json.price_min) ? `hide` : ``) + `">${$s.formatMoney(this.json.compare_at_price)}</span>
        </div>

        ` + (this.json.color_variant && this.json.color_variant != '' ? `
        <div class="available-colors">
          <div class="swatch-group inline-swatch-group flex align-items-center">
            <label title="${this.json.current_color}" class="swatch flex color-${$s.handleize(this.json.current_color)} align-items-center justify-content-center selected">
              <span class="visually-hidden">${this.json.current_color}</span>
            </label>
        ` : ``)

        var swatchesHtml = '';
        this.json.color_variant && this.json.color_variant.forEach((colorVariant) => {
          const handleizedTitle = $s.handleize(colorVariant.color);
          swatchesHtml += `<label title="${colorVariant.color}" class="swatch color-${handleizedTitle} flex align-items-center justify-content-center">
                            <span class="visually-hidden">${colorVariant.color}</span>
                          </label>`
        })

        swatchesHtml += `</div></div>`

        html += swatchesHtml;

        html += `
      </div>
    </div>
    <div class="atc-options-wrapper ${ !this.json.color_variant ? 'large--hide medium--hide' : 'atc-full-height' }">
      <a href="${this.json.url}">
        <div class="info large--hide medium--hide">
          ` + (this.json.eyebrow ? `<div class="eyebrow">${this.json.eyebrow}</div>` : ``) + `
          <div class="title">${this.json.title}</div>
          <div class="price-swatches-wrapper flex justify-content-between align-items-center small--direction-column small--align-items-start">
            <div class="price flex justify-content-${this.dataset.textAlign.replace('left','start').replace('right','end')}">
              ` + (this.json.price_min != this.json.price_max ? `<div class="from">From</div>` : ``) + `
              <span class="final ${( this.json.compare_at_price > this.json.price ) ? '' : 'regular-final'}">${$s.formatMoney(this.json.price_min)}</span>
              <span class="compare ` + (!(this.json.compare_at_price_min > this.json.price_min) ? `hide` : ``) + `">${$s.formatMoney(this.json.compare_at_price)}</span>
            </div>

            ` + (this.json.color_variant && this.json.color_variant != '' ? `
            <div class="available-colors">
              <div class="swatch-group inline-swatch-group flex align-items-center">
                <label title="${this.json.color_variant}" class="swatch flex color-${$s.handleize(this.json.color_variant)} align-items-center justify-content-center selected">
                  <span class="visually-hidden">${this.json.color_variant}</span>
                </label>
            ` : ``)

            var swatchesHtml = '';
            this.json.color_variant && this.json.color_variant.forEach((colorVariant) => {
              const handleizedTitle = $s.handleize(colorVariant.color);
              swatchesHtml += `<label title="${colorVariant.color}" class="swatch color-${handleizedTitle} flex align-items-center justify-content-center">
                                <span class="visually-hidden">${colorVariant.color}</span>
                              </label>`
            })

            swatchesHtml += `</div></div>`

            html += swatchesHtml;

            html += `
          </div>
        </div>
      </a>

      <div class="atc-options">Options</div>
      <form action="/cart/add" method="post" autocomplete="off" class="${this.json.variants.length==1 ? `no-variants` : ``}">
        <product-price class="flex">
            <span class="deal btn-price">${$s.formatMoney(this.defaultVariant.price)}</span>
            <span class="retail ` + (!(this.defaultVariant.compare_at_price > this.defaultVariant.price) ? `hide` : ``) + `">
              ${$s.formatMoney(this.defaultVariant.compare_at_price)}
            </span>
          </product-price>
        <div class="product-variants-container ${this.json.variants.length==1 ? `no-variants` : ``}">
          <product-variants ` + (this.json.variants.length==1 ? `class="visually-hidden"` : ``) + `>`;

      if (!this.json.has_only_default_variant) {
        var optionsHtml = '';
        this.json.options.forEach((option,ix)=> {
          if (option=='Color') {
            optionsHtml += `<product-swatch class="color-swatches" data-option="${ix + 1}" data-label="${option}"></product-swatch>`;
          } else if(option == 'Size') {
            optionsHtml += `<product-dropdown class="product-dropdown-variant" data-option="${ix + 1}" data-label="${option}"></product-dropdown>`;
          } else {
            optionsHtml += `<product-dropdown class="product-dropdown-variant" data-option="${ix + 1}" data-label="${option}"></product-dropdown>`;
          }
        });

        html += optionsHtml;
      }

      html += `
            <input data-variant-id="true" type="hidden" name="id" value="${this.defaultVariant.id}" />

          </product-variants>
        </div>

        ` + (this.dataset.showQuantity ? `
        <quantity-input class="quantity-box">
          <button class="quantity-button minus" type="button" aria-label="Decrease quantity of ${this.json.title.replaceAll('"', '&quot;')}">
            <svg aria-hidden="true" role="presentation" class="icon icon-minus" viewBox="0 0 32 32"><path fill="" d="M32,14.477v3.047H0v-3.047H32z"/></svg>
          </button>
          <input class="quantity-input"
            type="number"
            name="quantity"
            value="1"
            min="1"
            aria-label="Quantity of ${this.json.title.replaceAll('"', '&quot;')}"
          >
          <button class="quantity-button plus" type="button" aria-label="Increase quantity of ${this.json.title.replaceAll('"', '&quot;')}">
            <svg aria-hidden="true" role="presentation" class="icon icon-plus" viewBox="0 0 32 32"><path fill="" d="M17.524,17.524H32v-3.048H17.524V0h-3.048v14.476H0v3.048h14.476V32h3.048V17.524z"/></svg>
          </button>
        </quantity-input>
        ` : ``) + `
        <product-buttons>
          <button type="submit" class="btn add v3" ` + (!this.defaultVariant.available ? `disabled="disabled"` : ``) + `>
            <span class="one-whole btn-text" ` + (!this.defaultVariant.available ? `style="display:none;"` : ``) + `>
              <span class="">
                <span>ADD</span>
              </span>
            </span>
            <span class="sold-out-message" ` + (this.defaultVariant.available ? `style="display:none;"` : ``) + `>SOLD OUT</span>            
          </button>
        </product-buttons>
        <script type="application/json">
          ${this.dataset.json}
        </script>
      </form>
    </div>
  </add-to-cart-form>
</product-card-atc>
      `;
      return html;
    }
  }
  customElements.define('product-card-atc-js', ComponentProductCardAtcJs);
}